enum ETableSortDirection {
	ascending = 'ascending',
	descending = 'descending'
}

enum ETableType {
	quests,
	staking,
	campaigns,
	questsInCampaigns,
	questsInQuestLog
}

enum ETableLayout {
	fixed = 'fixed',
	auto = 'auto'
}

export { ETableLayout, ETableSortDirection, ETableType };
